(function () {
  'use strict';

  if (window.__bundleDiscoverySetInitialized) {
    return;
  }

  window.__bundleDiscoverySetInitialized = true;

  var SELECTORS = {
    section: '[data-section-type="bundle-discovery-set"]',
    searchInput: '.wi-bundle-discovery-set-search-input',
    productItem: '.wi-bundle-discovery-set-product-item[data-product-id]',
    productList: '.wi-bundle-discovery-set-product-list',
    selectionSlot: '.wi-bundle-discovery-set-selection-slot',
    actionBtn: '.wi-bundle-discovery-set-action-btn',
    actionLabel: '.wi-bundle-discovery-set-action-label',
    actionMeta: '.wi-bundle-discovery-set-action-meta',
    slotText: '.wi-bundle-discovery-set-selection-slot-text',
    slotContent: '.wi-bundle-discovery-set-selection-slot-content',
    slotRemove: '.wi-bundle-discovery-set-selection-slot-remove',
    notification: '.wi-bundle-discovery-set-notification',
    notificationClose: '.wi-bundle-discovery-set-notification-close',
    notificationText: '.wi-bundle-discovery-set-notification-text',
    picker: '.wi-bundle-discovery-set-picker',
    pickerPanel: '.wi-bundle-discovery-set-picker-panel',
    pickerBackdrop: '.wi-bundle-discovery-set-picker-backdrop',
    pickerClose: '.wi-bundle-discovery-set-picker-close',
    pickerFooterBtn: '.wi-bundle-discovery-set-picker-footer-btn',
    pickerFooterLabel: '.wi-bundle-discovery-set-picker-footer-label',
    pickerFooterMeta: '.wi-bundle-discovery-set-picker-footer-meta'
  };

  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');

  function isMobileView() {
    return MOBILE_MQ.matches;
  }

  /* --------------------------------------------------------------------------
     Utils
     -------------------------------------------------------------------------- */

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getCartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }

    return '/cart/add.js';
  }

  function getCartUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart) {
      return window.theme.routes.cart;
    }

    return '/cart.js';
  }

  function getCartUpdateUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartUpdate) {
      return window.theme.routes.cartUpdate;
    }

    return '/cart/update.js';
  }

  function rebuildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function isDiscoverySetBundleItem(item) {
    var props = item.properties || {};

    if (props._type === 'discovery_set_bundle') {
      return true;
    }

    return Object.keys(props).some(function (key) {
      return props[key] === 'discovery_set_bundle';
    });
  }

  function removeDiscoverySetBundleItems() {
    return fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var updates = {};

        cart.items.forEach(function (item) {
          if (isDiscoverySetBundleItem(item)) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) {
          return null;
        }

        return fetch(getCartUpdateUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function (error) {
        console.error('Discovery Set bundle remove error:', error);
      });
  }

  function initCartRemoveHandlers() {
    document.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('.removeDiscoverySetBundle');
      if (!removeBtn) return;

      event.preventDefault();

      removeDiscoverySetBundleItems().then(function () {
        rebuildCart();
      });
    });
  }

  /* --------------------------------------------------------------------------
     Mobile product picker modal
     -------------------------------------------------------------------------- */

  var Picker = {
    open: function (section) {
      if (!isMobileView()) return;

      var picker = section.querySelector(SELECTORS.picker);
      var panel = section.querySelector(SELECTORS.pickerPanel);
      if (!picker || !panel) return;

      picker.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('wi-bundle-discovery-set-picker-open');

      var searchInput = section.querySelector(SELECTORS.searchInput);
      if (searchInput) {
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      }
    },

    close: function (section) {
      var picker = section.querySelector(SELECTORS.picker);
      var panel = section.querySelector(SELECTORS.pickerPanel);
      if (!picker || !panel) return;

      picker.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('wi-bundle-discovery-set-picker-open');
    },

    init: function (section) {
      var picker = section.querySelector(SELECTORS.picker);
      if (!picker) return;

      var backdrop = picker.querySelector(SELECTORS.pickerBackdrop);
      var closeBtn = picker.querySelector(SELECTORS.pickerClose);

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          Picker.close(section);
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          Picker.close(section);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!picker.classList.contains('is-open')) return;

        Picker.close(section);
      });
    }
  };

  /* --------------------------------------------------------------------------
     Search — bundle-discovery-set-products.liquid
     -------------------------------------------------------------------------- */

  var Search = {
    init: function (section) {
      var searchInput = section.querySelector(SELECTORS.searchInput);
      var productItems = section.querySelectorAll(SELECTORS.productItem);

      if (!searchInput || !productItems.length) return;

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();

        productItems.forEach(function (item) {
          var title = (item.dataset.productTitle || '').toLowerCase();
          var titleFull = (item.dataset.productTitleFull || title).toLowerCase();
          var type = (item.dataset.productType || '').toLowerCase();
          var matches =
            !query ||
            title.indexOf(query) !== -1 ||
            titleFull.indexOf(query) !== -1 ||
            type.indexOf(query) !== -1;

          item.classList.toggle('is-hidden', !matches);
        });
      });
    }
  };

  /* --------------------------------------------------------------------------
     Notification toast
     -------------------------------------------------------------------------- */

  var Notification = {
    hideTimer: null,

    show: function (section) {
      var notification = section.querySelector(SELECTORS.notification);
      if (!notification) return;

      var message = section.dataset.incompleteMessage;
      var textEl = notification.querySelector(SELECTORS.notificationText);

      if (message && textEl) {
        textEl.textContent = message;
      }

      notification.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        notification.classList.add('is-visible');
      });

      window.clearTimeout(Notification.hideTimer);
      Notification.hideTimer = window.setTimeout(function () {
        Notification.hide(section);
      }, 5000);
    },

    hide: function (section) {
      var notification = section.querySelector(SELECTORS.notification);
      if (!notification) return;

      notification.classList.remove('is-visible');
      window.clearTimeout(Notification.hideTimer);

      window.setTimeout(function () {
        if (!notification.classList.contains('is-visible')) {
          notification.setAttribute('hidden', '');
        }
      }, 250);
    },

    init: function (section) {
      var notification = section.querySelector(SELECTORS.notification);
      if (!notification) return;

      var closeBtn = notification.querySelector(SELECTORS.notificationClose);

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          Notification.hide(section);
        });
      }
    }
  };

  /* --------------------------------------------------------------------------
     Selection & cart — products + featured-info snippets
     -------------------------------------------------------------------------- */

  var Selection = {
    init: function (section) {
      var maxSelections = parseInt(section.dataset.maxSelections, 10) || 6;
      var slotPlaceholder = section.dataset.slotPlaceholder || 'Choose a scent';
      var chooseLabel = section.dataset.buttonChooseLabel || 'Choose scents';
      var addToCartLabel = section.dataset.buttonAddToCartLabel || 'Add to cart';

      var productItems = section.querySelectorAll(SELECTORS.productItem);
      var slots = section.querySelectorAll(SELECTORS.selectionSlot);
      var actionBtn = section.querySelector(SELECTORS.actionBtn);
      var actionLabel = section.querySelector(SELECTORS.actionLabel);
      var actionMeta = section.querySelector(SELECTORS.actionMeta);
      var pickerFooterBtn = section.querySelector(SELECTORS.pickerFooterBtn);
      var pickerFooterLabel = section.querySelector(SELECTORS.pickerFooterLabel);
      var pickerFooterMeta = section.querySelector(SELECTORS.pickerFooterMeta);
      var pickerFooterText = section.dataset.pickerFooterLabel || 'Add to bundle';
      var pickerRemainingText = section.dataset.pickerRemainingLabel || 'Remaining';

      if (!productItems.length || !slots.length || !actionBtn) return;

      var selectedProducts = [];
      var isAddingToCart = false;

      function getProductFromItem(item) {
        return {
          id: item.dataset.productId,
          variantId: parseInt(item.dataset.variantId, 10),
          title: item.dataset.productTitle || '',
          price: parseInt(item.dataset.productPrice, 10) || 0
        };
      }

      function getProductSelectionCount(productId) {
        var count = 0;
        for (var i = 0; i < selectedProducts.length; i++) {
          if (selectedProducts[i].id === productId) count += 1;
        }
        return count;
      }

      function flashMaxReached() {
        actionBtn.classList.add('is-max-reached');
        window.setTimeout(function () {
          actionBtn.classList.remove('is-max-reached');
        }, 400);
      }

      function updateUI() {
        var count = selectedProducts.length;
        var isComplete = count === maxSelections;
        var totalPrice = 0;

        productItems.forEach(function (item) {
          var selectionCount = getProductSelectionCount(item.dataset.productId);
          var isSelected = selectionCount > 0;
          var row = item.querySelector('.wi-bundle-discovery-set-product-row');
          var checkEl = item.querySelector('.wi-bundle-discovery-set-product-check');
          var qtyEl = item.querySelector('.wi-bundle-discovery-set-qty');
          var qtyValue = item.querySelector('.wi-bundle-discovery-set-qty-value');
          var plusBtn = item.querySelector('.wi-bundle-discovery-set-qty-btn--plus');
          var minusBtn = item.querySelector('.wi-bundle-discovery-set-qty-btn--minus');

          item.classList.toggle('is-selected', isSelected);

          if (row) {
            row.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            if (isSelected) {
              row.setAttribute('aria-disabled', 'true');
            } else {
              row.removeAttribute('aria-disabled');
            }
          }

          if (checkEl && qtyEl && qtyValue) {
            if (selectionCount > 0) {
              checkEl.hidden = true;
              qtyEl.hidden = false;
              qtyValue.textContent = String(selectionCount);
            } else {
              checkEl.hidden = false;
              qtyEl.hidden = true;
              qtyValue.textContent = '1';
            }
          }

          if (plusBtn) {
            plusBtn.disabled = selectedProducts.length >= maxSelections;
          }

          if (minusBtn) {
            minusBtn.disabled = selectionCount === 0;
          }
        });

        slots.forEach(function (slot, index) {
          var slotContent = slot.querySelector(SELECTORS.slotContent);
          var slotText = slot.querySelector(SELECTORS.slotText);
          var removeBtn = slot.querySelector(SELECTORS.slotRemove);
          var product = selectedProducts[index];

          if (product && slotText) {
            slot.classList.add('is-filled');
            var displayTitle =
              window.theme && typeof theme.stripProductTitle === 'function'
                ? theme.stripProductTitle(product.title)
                : product.title;
            slotText.textContent = displayTitle;

            if (slotContent) {
              slotContent.setAttribute('role', 'button');
              slotContent.setAttribute('tabindex', '0');
              slotContent.setAttribute('aria-label', 'Remove ' + displayTitle);
            }

            if (removeBtn) {
              removeBtn.hidden = false;
              removeBtn.setAttribute('aria-hidden', 'true');
            }
          } else {
            slot.classList.remove('is-filled');

            if (slotText) slotText.textContent = slotPlaceholder;

            if (slotContent) {
              slotContent.removeAttribute('role');
              slotContent.removeAttribute('tabindex');
              slotContent.removeAttribute('aria-label');
            }

            if (removeBtn) {
              removeBtn.hidden = true;
              removeBtn.removeAttribute('aria-hidden');
            }
          }
        });

        selectedProducts.forEach(function (product) {
          totalPrice += product.price;
        });

        if (actionLabel) {
          actionLabel.textContent = isComplete ? addToCartLabel : chooseLabel;
        }

        if (actionMeta) {
          actionMeta.textContent = isComplete ? formatMoney(totalPrice) : count + '/' + maxSelections;
        }

        if (pickerFooterLabel) {
          pickerFooterLabel.textContent = isComplete ? addToCartLabel : pickerFooterText;
        }

        if (pickerFooterMeta) {
          pickerFooterMeta.textContent = isComplete
            ? formatMoney(totalPrice)
            : pickerRemainingText + ' ' + (maxSelections - count);
        }

        if (pickerFooterBtn) {
          pickerFooterBtn.classList.toggle('is-complete', isComplete);
          pickerFooterBtn.setAttribute('aria-disabled', isComplete ? 'false' : 'true');
        }

        if (isAddingToCart) {
          actionBtn.disabled = true;
          actionBtn.setAttribute('aria-disabled', 'true');
          actionBtn.classList.add('is-incomplete');
        } else if (isComplete) {
          actionBtn.disabled = false;
          actionBtn.setAttribute('aria-disabled', 'false');
          actionBtn.classList.remove('is-incomplete');
        } else {
          actionBtn.disabled = false;
          actionBtn.setAttribute('aria-disabled', 'true');
          actionBtn.classList.add('is-incomplete');
        }
      }

      function removeProductAtIndex(index) {
        if (index < 0 || index >= selectedProducts.length) return;

        selectedProducts.splice(index, 1);
        updateUI();
      }

      function removeOneProduct(item) {
        var productId = item.dataset.productId;

        for (var i = selectedProducts.length - 1; i >= 0; i--) {
          if (selectedProducts[i].id === productId) {
            selectedProducts.splice(i, 1);
            break;
          }
        }

        updateUI();
      }

      function addProduct(item) {
        var product = getProductFromItem(item);

        if (selectedProducts.length < maxSelections) {
          selectedProducts.push(product);
        } else {
          flashMaxReached();
          return;
        }

        updateUI();
      }

      slots.forEach(function (slot) {
        var slotContent = slot.querySelector(SELECTORS.slotContent);

        if (!slotContent) return;

        slotContent.addEventListener('click', function () {
          if (!slot.classList.contains('is-filled')) return;

          var index = parseInt(slot.dataset.slotIndex, 10);
          removeProductAtIndex(index);
        });

        slotContent.addEventListener('keydown', function (event) {
          if (!slot.classList.contains('is-filled')) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;

          event.preventDefault();

          var index = parseInt(slot.dataset.slotIndex, 10);
          removeProductAtIndex(index);
        });
      });

      productItems.forEach(function (item) {
        var row = item.querySelector('.wi-bundle-discovery-set-product-row');
        var minusBtn = item.querySelector('.wi-bundle-discovery-set-qty-btn--minus');
        var plusBtn = item.querySelector('.wi-bundle-discovery-set-qty-btn--plus');

        if (minusBtn) {
          minusBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            removeOneProduct(item);
          });
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            addProduct(item);
          });
        }

        if (!row) return;

        row.addEventListener('click', function (event) {
          if (event.target.closest('.wi-bundle-discovery-set-qty')) return;
          if (getProductSelectionCount(item.dataset.productId) > 0) return;
          addProduct(item);
        });

        row.addEventListener('keydown', function (event) {
          if (event.target.closest('.wi-bundle-discovery-set-qty')) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (getProductSelectionCount(item.dataset.productId) > 0) return;
          addProduct(item);
        });
      });

      function addToCart() {
        if (isAddingToCart) return;
        if (selectedProducts.length !== maxSelections) return;

        isAddingToCart = true;
        actionBtn.classList.add('btn--loading');
        actionBtn.disabled = true;

        if (pickerFooterBtn) {
          pickerFooterBtn.classList.add('btn--loading');
        }

        var bundleTitle = section.dataset.bundleCartTitle || 'The Custom Set';

        removeDiscoverySetBundleItems()
          .then(function () {
            return fetch(getCartAddUrl(), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: selectedProducts.map(function (product, index) {
                  return {
                    id: product.variantId,
                    quantity: 1,
                    properties: {
                      _type: 'discovery_set_bundle',
                      _bundle_title: bundleTitle,
                      _bundle_slot: String(index + 1)
                    }
                  };
                })
              })
            });
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.status && data.status === 422) {
              throw data;
            }

            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

            if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
              window.location = window.theme.routes.cartPage;
            }
          })
          .catch(function (error) {
            console.error('Bundle Discovery Set add to cart error:', error);
          })
          .finally(function () {
            isAddingToCart = false;
            actionBtn.classList.remove('btn--loading');
            if (pickerFooterBtn) {
              pickerFooterBtn.classList.remove('btn--loading');
            }
            updateUI();
          });
      }

      actionBtn.addEventListener('click', function () {
        if (isAddingToCart) return;

        if (selectedProducts.length !== maxSelections) {
          if (isMobileView()) {
            Picker.open(section);
          } else {
            Notification.show(section);
          }
          return;
        }

        addToCart();
      });

      if (pickerFooterBtn) {
        pickerFooterBtn.addEventListener('click', function () {
          if (isAddingToCart) return;

          if (selectedProducts.length !== maxSelections) {
            return;
          }

          Picker.close(section);
          addToCart();
        });
      }

      updateUI();
    }
  };

  /* --------------------------------------------------------------------------
     Layout — sticky offset for product column (page scrolls normally)
     -------------------------------------------------------------------------- */

  var Layout = {
    BOTTOM_GAP: 24,

    init: function (section) {
      document.documentElement.classList.remove('wi-bundle-discovery-set-page-scroll-lock');

      var self = this;

      var updateLayoutVars = function () {
        if (window.matchMedia('(max-width: 989px)').matches) {
          section.style.removeProperty('--wi-bundle-discovery-set-sticky-top');
          section.style.removeProperty('--wi-bundle-discovery-set-column-height');
          return;
        }

        var header =
          document.querySelector('.shopify-section-group-header-group') ||
          document.querySelector('#shopify-section-header') ||
          document.querySelector('.site-header');

        var topOffset = header ? Math.ceil(header.getBoundingClientRect().height) : 100;
        section.style.setProperty('--wi-bundle-discovery-set-sticky-top', topOffset + 'px');

        var sectionTop = Math.max(0, Math.ceil(section.getBoundingClientRect().top));
        var columnHeight = Math.max(
          400,
          window.innerHeight - sectionTop - self.BOTTOM_GAP
        );
        section.style.setProperty('--wi-bundle-discovery-set-column-height', columnHeight + 'px');
      };

      updateLayoutVars();
      window.addEventListener('resize', updateLayoutVars);
      window.addEventListener('load', updateLayoutVars);
      requestAnimationFrame(updateLayoutVars);

      if (typeof ResizeObserver !== 'undefined') {
        var layoutObserver = new ResizeObserver(updateLayoutVars);
        layoutObserver.observe(section);

        var headerEl =
          document.querySelector('.shopify-section-group-header-group') ||
          document.querySelector('#shopify-section-header') ||
          document.querySelector('.site-header');

        if (headerEl) {
          layoutObserver.observe(headerEl);
        }
      }
    }
  };

  /* --------------------------------------------------------------------------
     Product list images — bundle-discovery-set-products.liquid
     -------------------------------------------------------------------------- */

  var ProductImages = {
    init: function (section) {
      var productList = section.querySelector(SELECTORS.productList);
      if (!productList) return;

      var images = productList.querySelectorAll('img[loading="lazy"]');
      if (!images.length) return;

      if (!('IntersectionObserver' in window)) {
        images.forEach(function (img) {
          img.loading = 'eager';
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            var img = entry.target;
            img.loading = 'eager';

            if (img.dataset.src) {
              img.src = img.dataset.src;
            }

            observer.unobserve(img);
          });
        },
        {
          root: productList,
          rootMargin: '120px 0px',
          threshold: 0.01
        }
      );

      images.forEach(function (img) {
        observer.observe(img);
      });
    }
  };

  /* --------------------------------------------------------------------------
     Section init
     -------------------------------------------------------------------------- */

  function initSection(section) {
    if (section.getAttribute('data-bundle-discovery-set-init') === 'true') return;

    Search.init(section);
    Notification.init(section);
    Picker.init(section);
    Selection.init(section);
    ProductImages.init(section);
    Layout.init(section);

    section.setAttribute('data-bundle-discovery-set-init', 'true');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartRemoveHandlers();
    document.querySelectorAll(SELECTORS.section).forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SELECTORS.section);
    if (section) initSection(section);
  });
})();
